export default function VideoDemo() {
  const demoVideos = [
    {
      title: 'Local Business: Bakery',
      embedUrl: 'https://www.youtube.com/embed/Qs_ihWUw3Aw',
      description: 'See how our AI handles customer inquiries for a local bakery'
    },
    {
      title: 'Local Business: HVAC Company',
      embedUrl: 'https://www.youtube.com/embed/VIDEO_ID_2',
      description: 'Watch AI schedule appointments and answer technical questions'
    },
    {
      title: 'Professional Services: Optical Shop',
      embedUrl: 'https://www.youtube.com/embed/VIDEO_ID_3',
      description: 'Experience personalized customer service automation'
    }
  ];

  const recruitingVideos = [
    {
      title: 'Prescreening for a No-Code System Design & Development role',
      embedUrl: 'https://www.youtube.com/embed/VIDEO_ID_4',
      description: 'AI conducting technical screening interviews'
    },
    {
      title: 'Prescreening for an ML Software Engineer role',
      embedUrl: 'https://www.youtube.com/embed/VIDEO_ID_5',
      description: 'Automated candidate qualification process'
    },
    {
      title: 'Prescreening for a Senior Customer Support Specialist role',
      embedUrl: 'https://www.youtube.com/embed/VIDEO_ID_6',
      description: 'Efficient pre-screening for customer-facing roles'
    }
  ];

  return (
    <section id="video-demo" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            See Our AI Agents In Action
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Here are just a few samples of our AI Agents, taking calls in various industries, in action...
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {demoVideos.map((video, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="aspect-video bg-gray-900">
                <iframe
                  src={video.embedUrl}
                  title={video.title}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {video.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Sample Use Case: <span className="text-emerald-500 italic">Recruiters & HR Departments</span>
          </h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Voice AI Agents make mass outbound pre-screening of candidates a breeze... Here are just a few examples:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {recruitingVideos.map((video, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="aspect-video bg-gray-900">
                <iframe
                  src={video.embedUrl}
                  title={video.title}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {video.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {video.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
